import { ListingUseType } from "~/types/listing.types";

const VISIBLE_COUNT = 3;

const CATEGORY_GROUP_MAP: Record<string, string> = {
  catering_and_bartending: "Caterers and bartenders",
  catering_only: "Caterers and bartenders",
  bartending_only: "Caterers and bartenders",
  photography: "Photographers",
  live_music: "Musicians",
  live_music_dj: "Musicians",
  florals_and_design: "Florists and designers",
};

// Overrides CATEGORY_GROUP_MAP's label for a category_id when the listing's useType matches.
const CATEGORY_GROUP_MAP_BY_USE_TYPE: Partial<
  Record<ListingUseType, Record<string, string>>
> = {
  "Off-Site": {
    catering_and_bartending: "Caterers",
    catering_only: "Caterers",
    bartending_only: "Caterers",
  },
};

const CATEGORY_GROUP_ORDER = [
  "Caterers and bartenders",
  "Caterers",
  "Photographers",
  "Musicians",
  "Florists and designers",
];

export {
  VISIBLE_COUNT,
  CATEGORY_GROUP_MAP,
  CATEGORY_GROUP_MAP_BY_USE_TYPE,
  CATEGORY_GROUP_ORDER,
};
